import React from 'react';
import { Component } from 'react';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import * as ROUTES from '../../../constants/routes';
import PricingModal from './PricingModal';

const ViewButton = styled.div`
    .btn {
        color: #fafafa;
        border-color: ${(props) => props.themeColors.themeColor};
        background-color: ${(props) => props.themeColors.themeColor};
        margin: 2px;

        &:hover {
            color: #fafafa;
            background-color: ${(props) => props.themeColors.themeColor};
        }

        &:active {
            color: #fafafa;
            background-color: ${(props) => props.themeColors.themeColor};
        }
    }
`;

class PricingCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPaymentModal: false,
        }
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = () => {
        this.setState({ showPaymentModal: true });
    }

    handleCloseModal = () => {
        this.setState({ showPaymentModal: false });
    }

    render() {
        const schemeList = ['month', 'year', 'lifetime', 'day'];
        const featureStyle = {
            fontSize: "14px",
            lineHeight: "12px",
        };

        const { themeColors, isSignedIn, priceCard, modalStyles } = this.props;
        const { itemName, itemDescription, featureList, price, scheme, featured, productId } = priceCard;
        const schemeName = schemeList[scheme];
        const featuredText = featured ? <span style={{ fontSize: "18px" }}><b> - featured</b></span> : <span></span>;
        const corrFeaturedList = featureList ? [...featureList] : [];

        const relevantButton = isSignedIn ? <button className="btn btn-flat my-3" onClick={() => this.handleOpenModal()}>Subscribe to this plan</button> :
            <Link to={ROUTES.SIGN_UP} className="btn btn-flat my-3">Sign up for free</Link>

        return (
            <React.Fragment key={productId}>
                <div className="col p-3">
                    <div className="card" style={{ height: "540px" }}>
                        <div className="card-header">
                            <h4><b>{itemName}</b></h4>
                        </div>
                        <div className="card-body">
                            <br />
                            <blockquote className="blockquote">
                                <h3><span>${price}</span><span style={{ color: "gray" }}> /{schemeName}</span></h3>
                                <footer className="blockquote-footer">{itemDescription}</footer>
                            </blockquote>
                            <br />
                            <br />

                            {corrFeaturedList.map((eachFeature) => <p key={Math.random()} style={featureStyle}>{eachFeature}</p>)}
                        </div>
                        <div className="card-footer" style={{ backgroundColor: "white" }}>
                            <ViewButton themeColors={themeColors}>
                                {relevantButton}
                            </ViewButton>
                        </div>
                    </div>
                </div>

                {/* PAYMENT SELECTION MODAL */}
                <ReactModal
                    style={modalStyles}
                    isOpen={this.state.showPaymentModal}
                    onRequestClose={() => { this.handleCloseModal() }}
                    contentLabel="See all payment methods"
                    ariaHideApp={false}
                >
                    <button className="close" onClick={() => { this.handleCloseModal() }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <PricingModal priceCard={priceCard} />
                </ReactModal>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        isSignedIn: !state.firebase.auth.isEmpty,
        modalStyles: state.appControl.modalStyles,
    }
}

export default connect(mapStateToProps)(PricingCard);